/* tslint:disable */
/* eslint-disable */
/**
 * True one Services API
 * True one service for form Builder
 *
 * The version of the OpenAPI document: 4.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MeasurementSpec
 */
export interface MeasurementSpec {
    /**
     * 
     */
    key?: string;
    /**
     * 
     */
    label?: string;
    /**
     * 
     */
    unit?: string;
    /**
     * 
     */
    wearLimit?: number;
    /**
     * 
     */
    baselineValue?: number;
}

/**
 * Check if a given object implements the MeasurementSpec interface.
 */
export function instanceOfMeasurementSpec(value: object): value is MeasurementSpec {
    return true;
}

export function MeasurementSpecFromJSON(json: any): MeasurementSpec {
    return MeasurementSpecFromJSONTyped(json, false);
}

export function MeasurementSpecFromJSONTyped(json: any, ignoreDiscriminator: boolean): MeasurementSpec {
    if (json == null) {
        return json;
    }
    return {
        
        'key': json['key'] == null ? undefined : json['key'],
        'label': json['label'] == null ? undefined : json['label'],
        'unit': json['unit'] == null ? undefined : json['unit'],
        'wearLimit': json['wearLimit'] == null ? undefined : json['wearLimit'],
        'baselineValue': json['baselineValue'] == null ? undefined : json['baselineValue'],
    };
}

export function MeasurementSpecToJSON(json: any): MeasurementSpec {
    return MeasurementSpecToJSONTyped(json, false);
}

export function MeasurementSpecToJSONTyped(value?: MeasurementSpec | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'key': value['key'],
        'label': value['label'],
        'unit': value['unit'],
        'wearLimit': value['wearLimit'],
        'baselineValue': value['baselineValue'],
    };
}

